// prevention-plan.tsx
// Route : /prevention-plan — plan de prévention consolidé (Back Office, multi-sites/régions).
// Le filtrage par périmètre est appliqué côté serveur (GET /api/prevention-plan) ;
// tout utilisateur authentifié avec un rôle actif peut accéder à la page (elle
// n'affiche que les données de son périmètre, éventuellement vide).

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { MeasureDisplayStatus } from "@/domain/enums/measure-status";
import { AppLayout } from "@/presentation/layouts/AppLayout";
import { GlobalPreventionPlanPage } from "@/presentation/pages/GlobalPreventionPlanPage";

const preventionPlanSearchSchema = z.object({
  regionId: z.string().min(1).optional(),
  siteId: z.string().min(1).optional(),
  status: z.enum(["ToBePlanned", "InProgress", "Overdue"]).optional(),
});

interface PreventionPlanSearch {
  regionId?: string;
  siteId?: string;
  status?: MeasureDisplayStatus;
}

export const Route = createFileRoute("/prevention-plan")({
  component: function GlobalPreventionPlanComponent() {
    const search = Route.useSearch();

    return (
      <AppLayout>
        <GlobalPreventionPlanPage
          initialRegionId={search.regionId}
          initialSiteId={search.siteId}
          initialStatus={search.status}
        />
      </AppLayout>
    );
  },
  validateSearch: (search: Record<string, unknown>): PreventionPlanSearch => {
    const parsed = preventionPlanSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
});
